<template>
<div>
  <Modal class="modal-reg" width="524" v-model="modal2" :closable="false" :mask-closable="false" :footer-hide="true">
       <div slot="header" class="modal-reg-title">
            修改密码  <Icon  type="md-close" @click="close"/>
       </div>
      <div class="modal-reg-body" >
           <!-- <Row>
           <Col style="display:flex;">
               <span>账号</span>
                <input type="text" v-model="Tel">
              <Icon type="ios-close-circle" />
           </Col>
       </Row> -->
       <Row>
           <Col>
           <span>旧密码</span>
            <input v-model="password1" type="password">
        
           </Col>
       </Row>
         <Row>
           <Col>
           <span>新密码</span>
            <input v-model="password2" type="password">
           </Col>
       </Row>
       <button class="btn" @click="loginSubmit">确定</button>
      </div>
       <div slot="footer">
       </div>
    </Modal>
</div>
</template>
<script>
export default {
    props:{
        modal2:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return{
            Tel:'',
            password1:'',
            password2:'',
            code:'',
            type:0,
            isPassword:0,
        }
    },
    mounted(){
    },
    methods:{
        loginSubmit(){//登录
             var params={
                    //    Tel:this.Tel,
                       NewPassword:this.password2,
                       OldPassword:this.password1
                    }
        if((/^1[3456789]\d{9}$/.test(this.Tel))&&this.password2&&this.password1){
            this.$post('api/manage.PersonCenter/editPassword',params).then(res=>{
                        if(res.code==1){
                           this.$Message.success(res.msg)
                            this.$emit('clickLogin',false)
                        }else{
                            if(res.msg=='密码输入错误！'){
                                this.isPassword=2
                            }
                            this.$Message.error(res.msg)
                        }
                    })
        }else{
            this.$Message.error('请输入完整')
        }
        },
        close(){
            this.$emit('clickLogin',false)
        }
    }
}
</script>
<style lang="less" scoped>
.modal-reg{
     text-align: center;
  .modal-reg-title{
        background-color:#F0F2F1;
        text-align: center;
        padding:20px;
        color: #AAAAAA;
        font-size: 20px;
        i{
            float: right;
            font-size: 25px;
             cursor: pointer;
        }
    }
    .nav-title{
        height: 68px;
        line-height: 68px;
        display: flex;
        font-size: 14px;
        li{
            flex: 1;
            cursor: pointer;
        }
        li:nth-child(1){
            border-right:1px solid #83B3DA;
        }
        .active{
            background-color: #D4EFFF;
            color: #5597CC;
        }
    }
    .modal-reg-body{
        padding:0px 46px;
        .one{
        border:none;
        .ivu-col{
             div{  
                 display: flex;
              border-bottom:1px solid #E8EAE9;
             }
             .ivu-btn-info{
                 margin-left: 26px;
                 margin-top: 20px;
             }
        }
     }
    }
    .ivu-row{
        border-bottom:1px solid #E8EAE9;
        margin:20px 0px;
        .ivu-col{
            display: flex;
            >div{
                >span{
                    width: 74px;
                text-align: left;
                height: 50px;
                line-height: 50px;
                font-size: 15px;
                }
            }
            >span{
                width: 74px;
                text-align: left;
                height: 50px;
                line-height: 50px;
            }
            input{
              width: 220px;
              border:none;
            }
            .ivu-icon{
                font-size: 25px;
                color: #D81E06;
                 margin-left: 106px;
                 margin-top: 10px;
            }
            .ivu-icon-ios-checkmark-circle{
                color: #5BB531;
            }

        }
        
    }
    .btn{
        width: 422px;
        height: 37px;
        color: #fff;
        background-color: #056DC2;
        text-align: center;
        border:none;
        margin-top: 50px;
       margin-bottom:50px;
    }
    a{
    text-align: right;
    padding-bottom: 30px;
    display: block;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/changePws.vue